export enum ConversationChildTab {
  LiveChat = 'settings/channel/live-chat',
  Email = 'settings/channel/email',
  Facebook = 'settings/channel/facebook',
  Zalo = 'settings/channel/zalo',
  Sms = 'settings/channel/sms',
}

export const ConversationTabList = [
  {
    id: ConversationChildTab.LiveChat,
    title: 'LiveChat',
  },
  {
    id: ConversationChildTab.Email,
    title: 'Email',
  },
  {
    id: ConversationChildTab.Facebook,
    title: 'Facebook',
  },
  {
    id: ConversationChildTab.Zalo,
    title: 'Zalo',
  },
  {
    id: ConversationChildTab.Sms,
    title: 'SMS',
  },
];
export function getCurrentTab(url) {
  let tab = '';
  Object.keys(ConversationChildTab).forEach(s => {
    if (url.includes(ConversationChildTab[s])) {
      tab = ConversationChildTab[s];
    }
  });
  return tab;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/convertsation.const.ts